module.exports = __webpack_public_path__ + "img/UTDEAD-5.96f49094.jpg";